import React, { Component } from "reactn";
import { DialogTitle, DialogActions, Button, TextField } from "@material-ui/core";
import LinkDS from "js/react/views/PresentationSettings/dataservices/LinkDataService";
import { RowGrid } from "js/react/components/LayoutGrid";
import {
    BeautifulDialog,
    DialogContent,
    ShowSnackBar
} from "js/react/components/Dialogs/BaseDialog";
import { Gap20 } from "js/react/components/Gap";
import { trackActivity } from "js/core/utilities/utilities";
import { ToggleAllowCommenting } from "../components/ToggleAllowCommenting";
import LinkExpiration from "js/react/components/LinkExpiration";
import { ClipboardType, clipboardWrite } from "js/core/utilities/clipboard";

export default class PublicLinkDialog extends Component {
    constructor() {
        super();
        this.state = {
            accepted: false,
            fetching: true,
        };
        this.textFieldRef = React.createRef();
    }

    handleAccept = () => {
        LinkDS.saveLink(this.props.presentation, this.link).then(() => {
            ShowSnackBar({
                message: `Link for ${this.link.get(
                    "name"
                )} was copied to the clipboard`
            });
            this.setState({ accepted: true });
            this.props.closeDialog();
            this.copyToClipboard();
            const props = {
                presentation_id: this.props.presentation.id,
                link_ids: [this.link.get("id")],
                is_new: true,
                type: "public_link",
                workspace_id: this.props.presentation.getWorkspaceId()
            };
            trackActivity("Sharing", "CopyLink", null, null, props, { audit: true });
            this.props.callback && this.props.callback();
        });
    };

    handleUpdateLinkExpiration = ({ linkShouldExpire, linkHasExpired, linkExpiresAt }) => {
        this.setState({
            linkShouldExpire,
            linkHasExpired,
            linkExpiresAt
        });

        if (!linkHasExpired) {
            this.link.update({
                expiresAt: linkShouldExpire ? linkExpiresAt : null
            });
        }
    }

    copyToClipboard() {
        clipboardWrite({
            [ClipboardType.TEXT]: this.link.getLinkURL(),
        });
    }

    componentDidMount() {
        LinkDS.createPublicLink(this.props.presentation)
            .then(link => {
                this.link = link;
                this.setState({
                    fetching: false,
                    linkExpiresAt: link.get("expiresAt"),
                    linkHasExpired: link.shouldLinkExpire() && link.hasLinkExpired()
                });
            })
            .catch(err => {
                console.error(err);
            });
    }

    componentWillUnmount() {
        if (!this.state.accepted && this.link) {
            this.link.destroy();
        }
    }

    isTextSelected = field => {
        const closeWindow = field.selectionStart !== field.selectionEnd;

        // clear out existing selection ranges since JS will not do it on its own
        field.setSelectionRange(0, 0);
        window.getSelection && window.getSelection().removeAllRanges();

        return closeWindow;
    };

    toggleAllowCommenting = event => {
        if (this.link) {
            const allowCommenting = !this.link.attributes.allowCommenting;
            this.link.update({ allowCommenting });
            this.forceUpdate();
        }
    }

    render() {
        const { presentation } = this.props;
        const {
            fetching,
            linkExpiresAt,
            linkHasExpired,
        } = this.state;

        const disabled = fetching || linkHasExpired;

        const allowCommenting = this.link?.get("allowCommenting");

        return (
            <BeautifulDialog
                closeDialog={this.props.closeDialog}
            >
                <DialogTitle>Create Shareable Link</DialogTitle>
                <DialogContent>
                    <RowGrid gap={0}>
                        <h3>
                            Creates and copies a link to your clipboard.
                            Pro users can track engagement with comments and viewer analytics.
                        </h3>
                        <Gap20 />
                        <TextField
                            label="Add a name for this link"
                            value={fetching ? "" : this.link.get("name")}
                            onChange={event => {
                                this.link.update({ name: event.target.value });
                                this.forceUpdate();
                            }}
                            disabled={fetching}
                            inputRef={this.textFieldRef}
                        />
                        <Gap20 />

                        <ToggleAllowCommenting
                            allowCommenting={allowCommenting}
                            onToggle={this.toggleAllowCommenting}
                        />

                        <LinkExpiration
                            expiresAt={linkExpiresAt}
                            presentation={presentation}
                            onUpdate={this.handleUpdateLinkExpiration}
                            stacked
                        />

                    </RowGrid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.closeDialog}>Cancel</Button>
                    <Button onClick={this.handleAccept} disabled={disabled} color="primary">
                        Copy Link to Clipboard
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
